import { VideoFunctionListItem } from 'features/VideoFunction/models';
import { useContext } from 'react';
import { Droppable } from 'react-beautiful-dnd';
import { VideoFunctionContext } from '../VideoFunctionListTable';
import VideoFunctionRow from '../VideoFunctionRow';

export interface VideoFunctionRowListProps {
  data: VideoFunctionListItem[];
}

function VideoFunctionRowList({ data }: VideoFunctionRowListProps) {
  const videoFunctionContext = useContext(VideoFunctionContext);

  return (
    <Droppable droppableId="root">
      {(provided, snapshot) => (
        <div
          {...provided.droppableProps}
          ref={provided.innerRef}
          style={videoFunctionContext.getListStyle(snapshot.isDraggingOver)}
        >
          {data.map((item, index) => (
            <VideoFunctionRow key={item.id} rowData={item} rowIndex={index} />
          ))}
          {provided.placeholder}
        </div>
      )}
    </Droppable>
  );
}

export default VideoFunctionRowList;
